import { Component, ChangeDetectorRef } from "@angular/core";
import { AuthService } from "../core/services/auth.service";
import { MasterService } from "../core/services/master.service";
import { HttpResponse } from "@angular/common/http";
import { MessageService } from "../core/services/message.service";
import { CurrentTabsService } from "../core/services/current-tabs.service";
import { Menus, Pages } from "../core/model/menus";
import { NavLink, TabPermission } from "../core/model/navlink"
import { UserComponent } from '../pages/master/user/user.component';
import { CompanyComponent } from '../pages/master/company/company.component';
import { CustomerComponent } from '../pages/master/customer/customer.component';
import { CustomerDetailComponent } from '../pages/master/customer-detail/customer-detail.component';
import { MessageTemplateComponent } from '../pages/master/message-temp/message-temp.component';
import { CustomersService } from '../core/services/customers.service';
import { MenusData } from "./menu";
import { DashboardComponent } from "../pages/dashboard/dashboard/dashboard.component";
import { DeviceMasterComponent } from "../pages/master/device-master/device-master.component";
import { CompanyMasterComponent } from "../pages/master/company-master/company-master.component";
import { ShiftAllocationComponent } from "../pages/master/shift-allocation/shift-allocation.component";
import { ManualPunchComponent } from "../pages/master/manual-punch/manual-punch.component";
import { EmployeeLeaveEnteryComponent } from "../pages/master/employee-leave-entery/employee-leave-entery.component";
import { OtDayComponent } from "../pages/master/ot-day/ot-day.component";
import { OtHourComponent } from "../pages/master/ot-hour/ot-hour.component";
import { CompanyTypeComponent } from "../pages/master/company-type/company-type.component";

@Component({
  selector: "home-root",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})


export class HomeComponent {
  isCollapsed = true;
  navLinks: NavLink[];
  selectdTab = 0;
  menus: Menus[] = [];
  comps = {
    'Dashboard': DashboardComponent,
    'users': UserComponent,
    'workcategory': CustomerDetailComponent,
    'companytype' : CompanyComponent,
    'documenttype' : CompanyTypeComponent,
    'company' : CompanyComponent,
    'rolepermission' : EmployeeLeaveEnteryComponent,
    'documentupload' : '',
    'customers': CustomerComponent,
    'paymentmode': CompanyMasterComponent,
    'task': ManualPunchComponent,
    'messagetemplate': MessageTemplateComponent,
    'customerDetail': CustomerDetailComponent,
    'workfollowups': DeviceMasterComponent,
    'confirmedleads': ShiftAllocationComponent,
    'othourwise' : OtHourComponent,
    'otdaywise' : OtDayComponent,
  }
  userSearch;
  searchedUser = [];
  visible = false;
  openMap = {};

  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private currentTabsService: CurrentTabsService,
    private customerService: CustomersService,
    private ref: ChangeDetectorRef
  ) {
    this.getMenus();
    this.navLinks = [];
  }

  closeTab(tab): void {
    this.navLinks.splice(this.navLinks.indexOf(tab), 1);
    this.currentTabsService.tabs = this.navLinks;
  }

  addTab(page) {
    if (!this.reOccur(page.pageName)) {
      let link = {
        label: page.pageName,
        component: this.comps[(page.routeURL).toLowerCase()],
        permission: page.permission
      }
      this.navLinks.push(link);
      this.currentTabsService.tabs = this.navLinks;
    }
  }

  reOccur(name) {
    let x = this.navLinks.findIndex((res) => res.label == name);
    if (x === -1) {
      this.selectdTab = this.navLinks.length;
      return false;
    } else {
      this.selectdTab = x;
      return true;
    }
  }

  logOut() {
    this.authService.logout();
  }

  onSearchUser() {
    this.searchedUser = [];
    this.customerService.searchCustomers(this.userSearch).subscribe((res: HttpResponse<any>) => {
      if (res.status == 200) {
        if (res.body.returnCode == 1) {
          this.searchedUser = res.body.data;
          this.ref.detectChanges();
        } else {
          this.messageService.message("error", res.body.returnMsg, 5000);
        }
      } else {
        this.messageService.message("error", res.body.returnMsg, 5000);
      }
    });
  }

  onUserClick(user) {
    let permissions = {add: true, delete: true, edit: true, email: true, print: true, view: true};
    let tab = {
      pageName: "CD : "+user.name,
      permission: permissions,
      routeURL: "customerDetail"
    };
    this.currentTabsService.currentUser = user;
    this.userSearch = '';
    this.searchedUser = [];
    this.addTab(tab);
  }

  ngOnInit(): void {}
  getMenus() {
    // this.masterService.getMenus().subscribe((res: HttpResponse<any>) => {
    //   if (res.status == 200 && res.body.returnCode == 1) {
    //     this.menus = this.filterMenus(res.body.data);
    //     document.getElementById('hTrigger').click();
    //     document.getElementById('hTrigger').click();
    //   } else {
    //     this.messageService.message("error", res.body.returnMsg, 5000);
    //   }
    // });
    this.menus = this.filterMenus(MenusData);
    setTimeout(() => {
      document.getElementById('hTrigger').click();
      document.getElementById('hTrigger').click();
    }, 1000);
  }
  filterMenus(data) {
    let arr = [];
    let areaString = [];
    data.forEach(ele => {
      if (this.isValidate(ele)) {
        if(areaString.indexOf(ele.areaName) != -1) {
          arr.forEach(el => {
            if (el.areaName == ele.areaName) {
              el.areaPages.push(this.createPages(ele))
            }
          })
        } else {
          let menu: Menus = new Menus();
          menu.areaName = ele.areaName;
          menu.areaPages = [];
          menu.areaPages.push(this.createPages(ele));
          areaString.push(ele.areaName);
          arr.push(menu);
          if(menu.areaName == 'Masters') this.openMap[menu.areaName] = true;
          else this.openMap[menu.areaName] = false;
        }
      }
    })
    return arr;
  }
  isValidate(ele) {
    if (ele.view || ele.edit || ele.delete || ele.email || ele.add || ele.print) {
      return true;
    } else {
      return false;
    }
  }
  createPages(ele) {
    let page: Pages = new Pages();
    page.pageName = ele.pageName;
    page.routeURL = ele.permissionInternalName;
    let permission: TabPermission = new TabPermission();
    permission.add = ele.add;
    permission.delete = ele.delete;
    permission.edit = ele.edit;
    permission.email = ele.email;
    permission.print = ele.print;
    permission.view = ele.view;
    page.permission = permission;
    return page;
  }
  closePassReset(ev) {
    this.visible = ev;
  }
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
}